import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import {
  CreateWhiteMessageCommand,
  UpdateWhiteMessageCommand,
  WhiteMessageByIdDto,
} from 'src/app/core/api/models';
import { WhiteMessagesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { RegularExpressions } from 'src/app/core/constants/regular-expressions';
import { FormPageConfig } from 'src/app/core/models/form-page-config.model';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { SmsBodyModule } from "../../../../shared/components/sms-body/sms-body.module";


@Component({
    selector: 'app-organization-white-message-form',
    templateUrl: './organization-white-message-form.component.html',
    styleUrls: ['./organization-white-message-form.component.scss'],
    imports: [BaseFormModule, SmsBodyModule]
})
export class OrganizationWhiteMessageFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties

  formPageConfig: FormPageConfig<WhiteMessageByIdDto> = {};
  model: CreateWhiteMessageCommand = {};
  enterSms: string = '';
  returnText: string = '';
  exitSms: string = '';
  cancelText: string = '';

  //#endregion

  constructor(protected currentService: WhiteMessagesService) {
    super();
  }

  initForm(): void {
    this.form = new FormGroup({
      title: new FormControl('', [
        Validators.required,
        // Validators.pattern(RegularExpressions.smsBodyForbiddenCharacters),
      ]),
      enterSms: new FormControl('', [
        Validators.required,
        // Validators.pattern(RegularExpressions.smsBodyForbiddenCharacters),
      ]),
      exitSms: new FormControl('', [
        Validators.required,
        // Validators.pattern(RegularExpressions.smsBodyForbiddenCharacters),
      ]),
      returnText: new FormControl('', [
        Validators.required,
        // Validators.pattern(RegularExpressions.smsBodyForbiddenCharacters),
      ]),
      cancelText: new FormControl('', [
        Validators.required,
        // Validators.pattern(RegularExpressions.smsBodyForbiddenCharacters),
      ]),
      phonebookIds: new FormControl(''),
    });
  }

  ngOnInit() {
    super.ngOnInit();
    this.disablePhonebook();
  }

  disablePhonebook() {
    if (this.formPageConfig.isEditMode) this.form.get('phonebookIds').disable();
  }

  initModel() {
    try {
      // when form is edit mode
      if (this.formPageConfig.isEditMode) {
        this.model = {
          title: this.formPageConfig.editData.title,
          cancelText: this.formPageConfig.editData.cancelText,
          enterSms: this.formPageConfig.editData.enterSms,
          exitSms: this.formPageConfig.editData.exitSms,
          returnText: this.formPageConfig.editData.returnText,
          phonebookIds: this.formPageConfig.editData.phonebooks.map(
            (item) => item.id
          ),
        };
      } // when form is create mode
      else this.formPageConfig.editData = {};
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }

    this.enterSms = this.model.enterSms;
    this.returnText = this.model.returnText;
    this.exitSms = this.model.exitSms;
    this.cancelText = this.model.cancelText;
  }

  //#region api

  //Create
  baseCreateApi(model: CreateWhiteMessageCommand) {
    this.unSubs();
    this.loading = true;

    this.currentService
      .whiteMessagesCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateWhiteMessageCommand) {
    this.unSubs();
    this.loading = true;

    model.id = this.formPageConfig.editId;
    this.currentService
      .whiteMessagesUpdateWhiteMessagePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit(): void {
    super.onSubmit();
  }
}
